import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { MyBetsConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { UserService } from '@frontend/sports/user/feature';

import { PopupManager } from '../popup/popup-manager.service';

@Component({
    selector: 'ms-archived-bets',
    templateUrl: 'archived-bets-modal.component.html',
})
export class ArchivedBetsModalComponent implements OnInit {
    @Input() showTransactionBetsDialog = false;
    archivedBetsUrl: SafeResourceUrl;

    constructor(
        private sanitizer: DomSanitizer,
        public sitecore: Sitecore,
        protected mybetsConfig: MyBetsConfig,
        protected userService: UserService,
        protected popupManager: PopupManager,
    ) {}

    ngOnInit(): void {
        if (this.showTransactionBetsDialog && this.mybetsConfig.stadiumMyBetsTransactionsUrl) {
            this.archivedBetsUrl = this.transformUrl(this.mybetsConfig.stadiumMyBetsTransactionsUrl);
        } else if (!this.showTransactionBetsDialog && this.mybetsConfig.archivedMyBetsUrl) {
            this.archivedBetsUrl = this.transformUrl(this.mybetsConfig.archivedMyBetsUrl);
        }
    }

    close(): void {
        this.popupManager.close();
    }

    private transformUrl(iframeUrl: string): SafeResourceUrl {
        return this.sanitizer.bypassSecurityTrustResourceUrl(iframeUrl);
    }
}
